import {IProject, IUser} from './types'

export const HOME_PATH = 'home'
export const SIGN_PATH = 'sign'
export const ABOUT_PATH = 'about'
export const PROFILE_PATH = 'profile'
export const PROJECTS_PATH = 'projects'
export const LOGIN_PATH = 'login'
export const LOGOUT_PATH = 'logout'

export const getDefaultProject = (): IProject => ({
  id: '1',
  ownerId: '2',
  ownerName: 'Landskrona stad',
  consentName: 'Generellt bildsamtycke',
  projectName: 'Midsommar 2026',
  lastEdit: 0,
  newShare: false
})

export const getDefaultUser = (): IUser => ({
  id: '5',
  name: 'Frasse Fransson',
  phone: '',
  email: '',
  facebook: '',
  instagram: '',
  linkedIn: '',
  unsplash: '',
  web: '',
  thankYouMessage: '',
  profilePicture: '',
  scopes: ['admin'],
  firstTimeLogin: false,
  showTutorials: {
    linkSign: true,
    quickStart: true,
    qrCode: true,
    newShareProject: true
  }
})